import { StyleSheet, Platform, Dimensions } from 'react-native'

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  headerStyle: {
    borderBottomWidth: 0,
  },
  flatlistContainer: {
    marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 64 : 20,
    paddingBottom: 50,
    paddingHorizontal: 16,
  },
  flatlistHeaderContainer: {
    marginBottom: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 32 : 10,
    marginTop: 30,
  },
  flatlistHeaderTitle: {
    marginBottom: 5,
  },
  itemContainer: theme => ({
    flex: 1,
    backgroundColor: theme.colors.cardBackgroundColor,
    elevation: 2,
    shadowColor: 'rgba(0, 0, 0, 0.16)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowRadius: 4,
    shadowOpacity: 1,
    borderRadius: 6,
    marginVertical: 10,
    padding: 15,
    flexDirection: 'row',
    alignItems: 'center',
  }),

  itemInfoContainer: {
    flex: 1,
    marginLeft: 15,
  },
  itemDateTimeContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  listEmptyContainer: {
    flex: 1,
    alignItems: 'center',
  },
  listEmptyText: {
    textAlign: 'center',
    marginTop: 20,
  },
  headerContentWrapper: (top = 0) => {
    return {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginTop: 24 + top,
      marginHorizontal: 16,
      marginBottom: 5,
    }
  },
  closeIcon: (color = Colors.white) => {
    return {
      tintColor: color,
    }
  },
  containerSafe: (len) => ({
    flex: 1,
    minHeight: len * 130,
  }),


})

export default styles
